import { render, staticRenderFns } from "./show_modal.vue?vue&type=template&id=01ed406e"
import script from "./show_modal.vue?vue&type=script&lang=js"
export * from "./show_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports